import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { applySessionToken } from "../lib/authSession";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const fragment = location.hash || "";
        const params = new URLSearchParams(fragment.startsWith("#") ? fragment.slice(1) : fragment);
        const sessionId = params.get("session_id");

        (async () => {
            if (!sessionId) { navigate("/login", { replace: true }); return; }
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                applySessionToken(data);
                await refresh();
                toast(`Welcome to Loomara, ${data.name?.split(" ")[0] || "friend"} ✨`);
                navigate(data.role === "admin" ? "/admin" : "/account", { replace: true });
            } catch {
                toast("Google sign-in failed — please try again.");
                navigate("/login", { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
            <p className="font-serif italic text-sage-700">Welcoming you in…</p>
        </div>
    );
}
